import * as React from 'react';
import {List, Datagrid, TextField, BooleanField, ReferenceField} from 'react-admin';
import {RiskEdit} from './risk.edit.component';

export const RiskList = () => {
  return (
    <List
      sort={{field: 'id', order: 'ASC'}}
      exporter={false}
      children={
        <Datagrid className="oddRow" rowClick="edit" expand={RiskEdit}>
          <TextField source="title" />
          <ReferenceField source="riskTemplateId" reference="riskTemplates" link={false}>
            <TextField source="title" />
          </ReferenceField>
          <ReferenceField source="riskCategoryId" reference="riskCategories" link={false}>
            <TextField source="displayName" />
          </ReferenceField>
          <BooleanField source="startActive" />
        </Datagrid>
      }
    />
  );
};
